module.exports = __webpack_public_path__ + "758e42cc29eec387360f0df748b70d53.png";